import { MatPaginatorIntl } from '@angular/material/paginator'
import { TranslocoService } from '@ngneat/transloco'

export class PaginatorI18n {
  constructor(private readonly transloco: TranslocoService) {}

  getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl()
    paginatorIntl.itemsPerPageLabel = this.transloco.translate('itemsPerPageLabel')
    paginatorIntl.nextPageLabel = this.transloco.translate('nextPageLabel')
    paginatorIntl.previousPageLabel = this.transloco.translate('previousPageLabel')
    paginatorIntl.firstPageLabel = this.transloco.translate('firstPageLabel')
    paginatorIntl.lastPageLabel = this.transloco.translate('lastPageLabel')
    paginatorIntl.getRangeLabel = this.getRangeLabel.bind(this)
    return paginatorIntl
  }

  private getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      const t = this.transloco.translate('getRangeLabel')
      return t.replace('_length', `${length}`)
    }
    length = Math.max(length, 0)
    const startIndex = page * pageSize
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize


    const t = this.transloco.translate('getRangeLabel2')
    let e = t.replace('_startIndex', `${startIndex + 1}`)
    let u = e.replace('_endIndex', `${endIndex}`)
    let o = u.replace('_length', `${length}`)

    return o
  }
}
